module.exports = __webpack_public_path__ + "img/hic-ischemic-heart-disease-female.ae86cf72.png";